import { Component } from '@angular/core';

@Component({
  selector: 'demo-root',
  template: `<router-outlet></router-outlet>`
})
export class DemoRootComponent { }



// WEBPACK FOOTER //
// /Users/David/Sites/angular2-json-schema-form/src/demo/app/demo-root.component.ts